import React, { Component } from "react";
import _ from "lodash";
import VariantsBox from "../variantsBox/VariantsBox";
import styles from "./VariantsList.scss";

class VariantsList extends Component {
  componentDidMount() {
    this.initializeVariants();
  }

  initializeVariants = () => {
    const variants = this.props.variants;
    const acceptedFormat = [];

    if (variants && variants !== "undefined" && !_.isEmpty(variants)) {
      variants.map((variant, index) => {
        let sampleStocks = variant.stock_group;

        if (sampleStocks && !_.isEmpty(sampleStocks)) {
          for (let i = 0; i < sampleStocks.length; i++) {
            sampleStocks[i].quantity = sampleStocks[i]["stock_available"] || 0;
            sampleStocks[i].stock_updated = 0;

            // delete sampleStocks[i].stock_available;
          }
        }
        const variantFormat = {
          is_active: variant.is_active || "0",
          partner_sku: variant.partner_sku || "",
          partner_sku_unique: variant.partner_sku_unique || "",
          price: String(variant.price || ""),
          shipping_countries: this.props.shippingCountries,
          // id_processing_time: this.props.processingTime,
          id_warranty: this.props.warranty,
          offer_note: this.props.offerNote,
          offer_code: variant.offer_code,
          sku: variant.sku,
          stocks: sampleStocks,
          sale_price: String(variant.sale_price || ""),
          sale_start: String(variant.sale_start || ""),
          sale_end: String(variant.sale_end || "")
        };
        acceptedFormat.push(variantFormat);
      });
    }
    this.props.initialize(acceptedFormat);
  };
  render() {
    const {variants, isPartnerSkuUnique, partnerSkuUnique, seller} = this.props;
    const variantsList =
      variants && variants.length > 1
        ? variants.map((variant, index) => {
            return !_.isEmpty(variant) ? (
              <div className={styles.variantsBox} key={index + "Variant"}>
                <VariantsBox
                  variant={variant}
                  currencyCode={this.props.currencyCode}
                  onValueChange={this.props.onValueChange}
                  shipping_countries={this.props.shippingCountries}
                  offer_note={this.props.offerNote}
                  isPartnerSkuUnique={isPartnerSkuUnique}
                  partnerSkuUnique={partnerSkuUnique}
                  // id_processing_time={this.props.processingTime}
                  id_warranty={this.props.warranty}
                  countryCode={this.props.countryCode}
                  isFbn={this.props.isFbn}
                  browser={this.props.browser}
                  key={index + "Variant"}
                  seller={seller}
                  priceError={
                    this.props.priceError &&
                    !_.isEmpty(this.props.priceError) &&
                    this.props.priceError.indexOf(variant.sku) > -1
                  }
                  salePriceError={
                    this.props.salePriceError &&
                    !_.isEmpty(this.props.salePriceError) &&
                    this.props.salePriceError.indexOf(variant.sku) > -1
                  }
                  partnerSkuUniqueError={
                    this.props.partnerSkuUniqueError &&
                    !_.isEmpty(this.props.partnerSkuUniqueError) &&
                    this.props.partnerSkuUniqueError.indexOf(variant.sku) > -1
                  }
                  qtyError={
                    this.props.qtyError &&
                    !_.isEmpty(this.props.qtyError) &&
                    this.props.qtyError.indexOf(variant.sku) > -1
                  }
                  saleStartError={
                    this.props.saleStartError &&
                    !_.isEmpty(this.props.saleStartError) &&
                    this.props.saleStartError.indexOf(variant.sku) > -1
                  }
                  saleEndError={
                    this.props.saleEndError &&
                    !_.isEmpty(this.props.saleEndError) &&
                    this.props.saleEndError.indexOf(variant.sku) > -1
                  }
                />
              </div>
            ) : (
              ""
            );
          })
        : "";

    return (
      <div className={styles.ctr}>
        {variants && !_.isEmpty(variants) ? (
          <div>
            {variants.length > 1 ? (
              variantsList
            ) : (
              <VariantsBox
                variant={variants[0]}
                seller={seller}
                isPartnerSkuUnique={isPartnerSkuUnique}
                partnerSkuUnique={partnerSkuUnique}
                currencyCode={this.props.currencyCode}
                onValueChange={this.props.onValueChange}
                shipping_countries={this.props.shippingCountries}
                offer_note={this.props.offerNote}
                // id_processing_time={this.props.processingTime}
                id_warranty={this.props.warranty}
                offer_code={this.props.offerCode}
                countryCode={this.props.countryCode}
                isFbn={this.props.isFbn}
                browser={this.props.browser}
                singleVariant
                is_active={this.props.is_active}
                priceError={
                  this.props.priceError &&
                  !_.isEmpty(this.props.priceError) &&
                  this.props.priceError.indexOf(variants[0].sku) > -1
                }
                salePriceError={
                  this.props.salePriceError &&
                  !_.isEmpty(this.props.salePriceError) &&
                  this.props.salePriceError.indexOf(variants[0].sku) > -1
                }
                partnerSkuUniqueError={
                  this.props.partnerSkuUniqueError &&
                  !_.isEmpty(this.props.partnerSkuUniqueError) &&
                  this.props.partnerSkuUniqueError.indexOf(variants[0].sku) > -1
                }
                qtyError={
                  this.props.qtyError &&
                  !_.isEmpty(this.props.qtyError) &&
                  this.props.qtyError.indexOf(variants[0].sku) > -1
                }
                saleStartError={
                  this.props.saleStartError &&
                  !_.isEmpty(this.props.saleStartError) &&
                  this.props.saleStartError.indexOf(variants[0].sku) > -1
                }
                saleEndError={
                  this.props.saleEndError &&
                  !_.isEmpty(this.props.saleEndError) &&
                  this.props.saleEndError.indexOf(variants[0].sku) > -1
                }
              />
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default VariantsList;



// WEBPACK FOOTER //
// ./src/components/products/offerDetails/variantsList/VariantsList.js